<div *ngIf="show" class="ib-layout__line-spacing ib-layout__line-spacing--large ib-layout__line-spacing--bordered">
    <div class="row">
        <div class="col-xs-12">
            <div class="ib-gift-card-info u-text-center">
                <h2 class="ib-gift-card-info__title">{{ 'GIFT_CARD_CONFIGURATION_YOUR_GIFT_CARD' | translate }}</h2>
                <div class="ib-gift-card-info__container">
                    <div class="ib-gift-card">
                        <figure class="ib-gift-card__logo" [ngSwitch]="theme">
                            <img [src]="viewModel?.logo" [alt]="viewModel?.translates?.altLogo" />
                        </figure>
                        <figure class="ib-gift-card__figure" [ngSwitch]="theme">
                            <img [src]="viewModel?.backGroundImage" [alt]="viewModel?.translates?.altFigure" />
                        </figure>
                        <figure class="ib-gift-card__icon"
                                [ngClass]="viewModel?.iconClass"
                                [ngSwitch]="theme">
                            <img [src]="viewModel?.icon" [alt]="viewModel?.translates?.altTheme" />
                        </figure>
                        <div class="ib-gift-card__description">
                            <span class="ib-gift-card__title">{{ viewModel?.translates?.title }}</span>
                            <span class="ib-gift-card__price" [ngClass]="{'ib-gift-card__price--long-coins': model.price.length >= 5}">
                                {{ model.price }}
                            </span>
                            <span class="ib-gift-card__txt">{{ viewModel?.translates?.expiration }} mm/dd/aaaa</span>
                            <span class="ib-gift-card__txt">{{ viewModel?.translates?.code }} xxx xxx xxx</span>
                        </div>
                    </div>
                    <span class="ib-gift-card-info__img-txt">{{ message }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
